import React, { useEffect, useState } from 'react'
import { Button, Calendar, Col, Dropdown, Menu, Radio, Row } from 'antd'
import images1 from '../../assets/images1.jfif'
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { BsPencil } from 'react-icons/bs';
import EditStaffForm from './EditStaffForm';
import EditCircle from '../../assets/icons/edit-circle.svg'

function PersonalInfo({staffDetail, callCurrentStaff}) {
const [firstLetters, setFirstLetters] = useState([])
const [formVisible, setFormVisible] = useState(false);
const [editItem, setEditItem] = useState(null);

    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const showForm = (item) => {
       
        setFormVisible(true);
      };
    const hideForm = (item) => {
        
        setFormVisible(false);
        callCurrentStaff()
      };
    const formatDate = (timestamp) => {
        const months = [
          'Jan', 'Feb', 'March', 'April',
          'May', 'June', 'July', 'Aug',
          'Sept', 'Oct', 'Nov', 'Dec'
        ];
      
        const date = new Date(timestamp);
        const day = date.getUTCDate();
        const month = months[date.getUTCMonth()];
        const year = date.getUTCFullYear();
        // Add a zero in front of the day if it's a single digit
        const formattedDay = day < 10 ? `0${day}` : day;
      
        const formattedDate = `${formattedDay} ${month} ${year}`;
      
        return formattedDate;
      };

      const getDayLetter = (dayNumber) => {
        const days = ['S', 'M', 'T', 'W', 'T', 'F', 'S']; 
        return days[dayNumber];
    };
       
        useEffect(() => {
            if( staffDetail?.workingDays && staffDetail?.workingDays.length > 0){
     
                setFirstLetters(staffDetail?.workingDays?.map(dayNumber => {
                    return getDayLetter(dayNumber);
                }));
            ;
             }
          }, [staffDetail?.workingDays]);

          function formatTimeWithAMPM(milliseconds) {
            const hours = Math.floor(milliseconds / 3600000);
            const minutes = Math.round((milliseconds % 3600000) / 60000);
          
            const formattedHours = hours % 12 || 12;
            const ampm = hours >= 12 ? 'PM' : 'AM';
          
            return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
          }
    return (
        <div className='mt-3'>
        <ToastContainer position="top-right" autoClose={5000} />

            {/* <p className='Compulsory'>Compulsory Data (EID - E101)</p> */}
            <div className='gap-4 grid grid-cols-12'>
                <div className='col-span-6'>
                    <p className='text-lg text-[#4B8AEB] font-sbold'>Basic Details</p>
                    <div className='bg-[#EDF3FD] rounded-[25px] !p-3 relative !pr-[52px]'>
                    <Row gutter={16} className='m-0'>
                        {/* <Col lg={24}> */}
                        <div className="bg-[#CDDEF9] rounded-lg px-3 py-2 mr-2.5" style={{ display: "flex", flexDirection: "column" }}>
                        <h4 className='text-[#6C94B4] text-[17px] mb-1'>DOB</h4>
                        <p className='text-xl leading-none'>{staffDetail?.dob ? formatDate(staffDetail?.dob) : '--'}</p>
                        </div>
                        {/* <div className="mb-3 staffDetailBoxes" style={{ display: "flex", flexDirection: "column" }}>
                        <h4>Age</h4>
                        <p>26 </p>
                        </div> */}
                        <div className="bg-[#CDDEF9] rounded-lg px-3 py-2 mr-2.5" style={{ display: "flex", flexDirection: "column" }}>
                        <h4 className='text-[#6C94B4] text-[17px] mb-1'>Gender</h4>
                        <p className='text-xl leading-none'>{staffDetail?.gender ? capitalizeFirstLetter(staffDetail?.gender) : '--'}</p>
                        </div>
                        <div className="bg-[#CDDEF9] rounded-lg px-3 py-2 mr-2.5" style={{ display: "flex", flexDirection: "column" }}>
                        <h4 className='text-[#6C94B4] text-[17px] mb-1'>Personal Number</h4>
                        <p className='text-xl leading-none'>{staffDetail?.phoneNumber}</p>
                        </div>
                        <div className="bg-[#CDDEF9] rounded-lg px-3 py-2 mr-2.5" style={{ display: "flex", flexDirection: "column" }}>
                        <h4 className='text-[#6C94B4] text-[17px] mb-1'>Permanent Address</h4>
                        <p className='text-xl leading-none'>{staffDetail?.permanentAddress ? capitalizeFirstLetter(staffDetail?.permanentAddress) : '--'}</p>
                        </div>
                        {/* <div className="mb-3 staffDetailBoxes" style={{ display: "flex", flexDirection: "column" }}>
                        <h4>Aadhar Number</h4>
                        <p>{staffDetail?.permanentAddress ? staffDetail?.permanentAddress : '--'}</p>
                        </div> */}
                        <img src={EditCircle} onClick={() => showForm()} className='absolute top-4 right-4 cursor-pointer'/>
                    </Row>

                 

                       
                    </div>
                 </div>
                 <div className='col-span-6'>
                    <p className='text-lg text-[#4B8AEB] font-sbold'>WORK DETAILS</p>
                    <div className='bg-[#EDF3FD] rounded-[25px] !p-3 relative'>
                        <div className='grid grid-cols-12 gap-y-2'>
                            <div className="bg-[#CDDEF9] rounded-lg px-3 py-2 !pr-10 col-span-6">
                                <h4 className='text-[#6C94B4] text-[17px] mb-1'>Date of Joining</h4>
                                <p className='text-xl leading-none'>{staffDetail?.doj ? formatDate(staffDetail?.doj) : '--'}</p>
                            </div>
                            <div className="bg-[#CDDEF9] rounded-lg px-3 py-3 col-span-12 gap-y-2 flex flex-col">
                                <div className='grid grid-cols-12 items-center'>
                                    <h4 className='text-[#6C94B4] text-[17px] col-span-4'>Shift</h4>
                                    <p className='col-span-8 text-xl'>{capitalizeFirstLetter(staffDetail?.shift?.shiftFullName)} </p>
                                </div>
                                <div className='grid grid-cols-12 items-center'>
                                    <h4 className='text-[#6C94B4] text-[17px] col-span-4'>Work Days</h4>
                                    <p className='col-span-8 text-xl flex gap-1'>{firstLetters?.map((letter, index) => (<span key={index}>{letter}</span>))}</p>
                                </div>
                                <div className='grid grid-cols-12 items-center'>
                                    <h4 className='text-[#6C94B4] text-[17px] col-span-4'>Time</h4>
                                    <p className='col-span-8 text-xl'>{formatTimeWithAMPM(staffDetail?.shift?.shiftStartTime)} - {formatTimeWithAMPM(staffDetail?.shift?.shiftEndTime)} </p>
                                </div>
                                <div className='grid grid-cols-12 items-center'>
                                    <h4 className='text-[#6C94B4] text-[17px] col-span-4'>Sites</h4>
                                    <p className='col-span-8 text-xl'>{capitalizeFirstLetter(staffDetail?.mainSite?.map(item => item?.locationName1).join(', '))} </p>
                                </div>
                            </div>
                            <img src={EditCircle} onClick={() => showForm()} className='absolute top-4 right-4 cursor-pointer'/>
                        </div>
                    </div>
                </div>
            </div>
            <EditStaffForm
        open={formVisible}
        onCancel={hideForm}
        initialValue={staffDetail}
       />
        </div>
    )
}

export default PersonalInfo